import React from 'react';
import './HoursWorkedTooltip.css';

const HoursWorkedTooltip = ({ position }) => {
  return (
    <div 
      className="hours-worked-tooltip"
      style={{
        top: `${position.y}px`,
        left: `${position.x}px`,
      }}
    >
      <div className="tooltip-title">
        Exclusive Benefit Rule / Bona Fide Employee
      </div>
      <div className="tooltip-content">
        The person who rolls their retirement funds into the ROBS structure must be a bona fide employee of the business they've funded. The rule is somewhat vague, but to be safe, Guidant suggests the owner work at least 500 hours per year.
      </div>
    </div>
  );
};

export default HoursWorkedTooltip;